import styled from 'styled-components'

export const RadioInput = styled.input.attrs({
	type: 'radio',
})`
	position: absolute;
	opacity: 0;
	pointer-events: none;
`
